import axios from 'axios'

// config
import baseUrl from '../config'

export const fetchCourses = async params => {
  const response = await axios.get(`${baseUrl}/levelup/courses`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchCourseCategories = async params => {
  const response = await axios.get(`${baseUrl}/levelup/course-categories`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchCourseCollections = async params => {
  const response = await axios.get(`${baseUrl}/levelup/course-collections`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchGrowthGuides = async params => {
  const response = await axios.get(`${baseUrl}/levelup/guides`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const registerForLevelUp = async data => {
  return await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/levelup/register`,
    data
  })
}
